export const DEPARTMENTS_RESET_STATE = 'DEPARTMENTS_RESET_STATE';
export const DEPARTMENTS_CURRENT_ITEM = 'DEPARTMENTS_CURRENT_ITEM';

export const DEPARTMENTS_REQUEST_LOADING = 'DEPARTMENTS_REQUEST_LOADING';
export const DEPARTMENTS_REQUEST_SUCCESS = 'DEPARTMENTS_REQUEST_SUCCESS';
export const DEPARTMENTS_REQUEST_FAILED = 'DEPARTMENTS_REQUEST_FAILED';

export const DEPARTMENTS_CURRENT_ACTION = 'DEPARTMENTS_CURRENT_ACTION';
export const DEPARTMENTS_RESET_ACTION = 'DEPARTMENTS_RESET_ACTION';